@switch (buildInfo.environment) {
  @case ('local') {
    <div class="py-1 bg-feedback-bg-help w-full text-feedback-fg-help text-center border-t border-b border-feedback-border-default">
      <p>LOCAL - {{backendVersion()}} - RDU-FE-{{buildInfo.version}}</p>
    </div>
  }
  @case ('develop') {
    <div class="py-1 bg-feedback-bg-help w-full text-feedback-fg-help text-center border-t border-b border-feedback-border-default">
      <p>DEV - {{backendVersion()}} - RDU-FE-{{buildInfo.version}}</p>
    </div>
  }
  @case ('staging') {
    <div class="py-1 bg-feedback-bg-purple w-full text-feedback-fg-purple text-center border-t border-b border-feedback-border-purple">
      <p class="text-body-lg-weight-medium">STAGING - {{backendVersion()}} - RDU-FE-{{buildInfo.version}}</p>
    </div>
  }
  @case ('sandbox') {
    <div class="py-1 bg-feedback-bg-purple w-full text-feedback-fg-purple text-center border-t border-b border-feedback-border-purple">
      <p class="text-body-lg-weight-medium">SANDBOX - {{backendVersion()}} - RDU-FE-{{buildInfo.version}}</p>
    </div>
  }
  @case ('preprod') {
    <div class="py-1 bg-feedback-bg-locking w-full text-feedback-fg-locking text-center border-t border-b border-feedback-border-locking">
      <p class="text-body-lg-weight-medium">PREPROD - {{backendVersion()}} - RDU-FE-{{buildInfo.version}}</p>
    </div>
  }
}
